namespace GeniuzPOS.SalePromoCamp {
    export class PsPromoApHdColumns {
        static columnsKey = 'SalePromoCamp.PsPromoApHd';
    }
}
